// extracted by mini-css-extract-plugin
export default {"videoWrapper":"Confetti_videoWrapper__YzzQO","confetti":"Confetti_confetti__GPncX"};